export const formatFileSize = (size) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) {
    const kb = size / 1024;
    return `${Number(kb.toFixed(1))} KB`;
  }
  const mb = size / (1024 * 1024);
  return `${Number(mb.toFixed(1))} MB`;
};
